export class CompanyManagelistModel {
    // show to company list
    companySurrKey: number = 0;
    companyName: string = "";
    companyUserRole: string = "";
    companyLogo: string = "";
    companyPhone: string = "";
    companyEmail: string = "";
    companygrade: string = "";
    countryName: string = "";
    provinceName: string = "";
    districtName: string = "";
    createdUserId: number = 0;
    isBadge: boolean = false;
    userCreateEmail: string = "";
    createdate: string = "";
    companyhide: string = "";
    qoCount: number = 0;
    qowin: number = 0;
    qowait: number = 0;
    qolost: number = 0;
    qofollow: number = 0;
    soCount: number = 0;
    soTotalexvat: number = 0;
    // using for change page
    page: number = 0;
    limit: number = 0;
    // using for sort
    sortcol: string = "";
    sorttype: number = 0;
}
